import React from 'react';
import PropTypes from 'prop-types';

const ConfirmableLink = ({ children, message, onConfirmation }) => {
  const handle = ev => {
    ev.preventDefault();

    const confirmation = window.confirm(message);

    if (confirmation) {
      onConfirmation();
    }
  };

  return <button onClick={handle}>{children}</button>;
};

ConfirmableLink.propTypes = {
  children:       PropTypes.node.isRequired,
  onConfirmation: PropTypes.func.isRequired,
  message:        PropTypes.string.isRequired
};

export default ConfirmableLink;
